import { render } from "./item.vue?vue&type=template&id=3275c383"
import script from "./item.vue?vue&type=script&lang=js"
export * from "./item.vue?vue&type=script&lang=js"
script.render = render

export default script